var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgrupamientos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 158.333H41.6667C37.2464 158.333 33.0072 156.577 29.8816 153.452C26.7559 150.326 25 146.087 25 141.667V49.9999C25 45.5796 26.7559 41.3404 29.8816 38.2148C33.0072 35.0892 37.2464 33.3333 41.6667 33.3333H75L100 58.3333H158.333C162.754 58.3333 166.993 60.0892 170.118 63.2148C173.244 66.3404 175 70.5796 175 74.9999V104.167M133.333 158.333H183.333M158.333 133.333V183.333",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgrupamientos);
export default __webpack_public_path__ + "static/media/Agrupamientos.392f0f2a3645e60a4c3d3db1073fc299.svg";
export { ForwardRef as ReactComponent };